import * as React from "react";
import { FC } from "react";
import "./PopupButton.scss";

export interface IPopupButton {
    title: string;
    icon?: string;
    classname?: string;
    disabled?: boolean;
    onClick: () => void;
}
export const PopupButton: FC<IPopupButton> = (props) => {
    const classname = [
        "popup-button",
        "unselectable",
        props.classname ? props.classname : "default",
        props.disabled ? "disabled" : ""
    ].join(" ");

    const onClick = () => {
        !props.disabled && props.onClick();
    };

    return (
        <a role="button" className={classname} onClick={onClick}>
            {props.icon ? <span className={props.icon}></span> : null}
            <span>{props.title}</span>
        </a>
    );
};
